import { CancelledError } from "@tanstack/react-query";

import { apiErrorStatus } from "@/core/lib/api-errors";

import { getFaro } from "./faro";

interface RouteErrorReport {
  error: Error;
  // string-keyed so it drops straight into faro's ExceptionContext
  context: Record<string, string>;
}

// which errors are worth reporting is the interesting part, so it is kept
// separate from the faro hand-off and can be asserted without standing in
// for the faro module. null means "suppress".
export function buildRouteErrorReport(error: unknown): RouteErrorReport | null {
  // auth teardown removes in-flight user queries while beforeLoad still
  // awaits them; that cancellation is an expected side effect of the
  // sign-in redirect, not an app failure
  if (error instanceof CancelledError) return null;

  const status = apiErrorStatus(error);
  if (status !== undefined && status >= 400 && status < 500) {
    return null;
  }

  return {
    error: error instanceof Error ? error : new Error(String(error)),
    context: {
      area: "router",
      errorBoundary: "true",
      pathname: globalThis.location.pathname,
      source: "route",
    },
  };
}

export function reportRouteError(error: unknown): void {
  const report = buildRouteErrorReport(error);
  if (!report) return;

  getFaro()?.api.pushError(report.error, { context: report.context });
}
